import React, {useEffect, useState} from "react";
import {getOtherRoles, getPCContractors} from 'api';
import {Button, Form, Input, Table, Row, Col, Modal} from "antd";
import {confirmAlert} from "react-confirm-alert";
import {isAdministrator} from "../../../utils/UserInfo";
import AddPCContractorDialog from "./AddPCContractorDialog";
import {
    commonSorter,
    SearchAndDropdownComponent,
    searchAndDropDownFilters,
    searchAndDropDownOnFilters
} from "../../../utils/AntdTableFunctions";

function PCContractorView(props){

    const [pcContractors,setPCContractors] = useState([]);

    useEffect(() => {
        async function getData() {
            let response = await getPCContractors();
            setPCContractors(response.data);
        }
        getData();
    }, []);

    function OpenNewOtherRoleDialog()
    {
        confirmAlert({
            closeOnClickOutside: false,
            closeOnEscape: false,
            customUI: ({ onClose }) => {
                return (
                    <AddPCContractorDialog onClose={onClose} setPCContractors={setPCContractors}/>
                );
            }
        });
    }

    const contractorColumns = [
        {
            title: ' P&C Contractor Company Name ',
            dataIndex: 'pcContractor',
            key: 'pcContractor',
            sorter: (a,b) => commonSorter(a,b,'pcContractor'),
            filters: searchAndDropDownFilters('pcContractor', pcContractors),
            ...SearchAndDropdownComponent(),
            onFilter: (value, record) =>  searchAndDropDownOnFilters(value, record,'pcContractor'),
        },
        {
            title: 'Added By',
            dataIndex: 'createdByName',
            key: 'createdByName'
        },
        {
            title: 'Added Date',
            dataIndex: 'createdDate',
            key: 'createdDate'
        },
        {
            title: 'Edited By',
            dataIndex: 'lastModifiedByName',
            key: 'lastModifiedByName'
        },
        {
            title: 'Edited Date',
            dataIndex: 'lastModifiedDate',
            key: 'lastModifiedDate'
        }
    ];

    return (
        <div>
            <div>
                <Row>
                    <Col>
                        {isAdministrator() &&
                        <Button
                            type='primary'
                            style={{alignItems: 'end', alignContent: 'end'}}
                            onClick={() => OpenNewOtherRoleDialog()}
                        >
                            Add New P&C Contractor
                        </Button>
                        }
                    </Col>
                </Row>
            </div>
            <Table
                bordered
                dataSource={pcContractors}
                columns={contractorColumns}
                pagination={false}
                scroll={{ y: true }}
                style={{ paddingTop: '15px', paddingBottom: '15px' }}
            />
        </div>
    )
}
export default PCContractorView;